import React, {FunctionComponent, lazy} from "react";
import {makeStyles} from "tss-react/mui";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import {
    OPEN_STATION_INFO,
    TOGGLE_HIDE_UNAVAILABLE_VEHICLES,
    TOGGLE_STATION,
    TOGGLE_VEHICLES_IN_STATION,
} from "@/Redux/Disposition/Constants";
import {Theme, Tooltip} from "@mui/material";
import {useAppDispatch, useAppSelector} from "@/Redux/Redux";
import {useDrop} from "react-dnd";
import {useConfirm} from "material-ui-confirm";
import {useSelector} from "react-redux";
import {selectMandant} from "@/Redux/App/AppReducer";
import {DateRangeOutlined} from "@mui/icons-material";
import {useHistory} from "react-router-dom";
import moment from "moment/moment";
import {logger} from "@/Logger";
import {selectViewerEnabledStations, ViewerState,} from "@/Redux/Auth/AuthReducer";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

const BookingOverlayWrapper = lazy(
    () =>
        import(
            "../../../../BookingManagement/Booking/Shared/Containers/BookingOverlayWrapper"
            )
);

interface DispositionLineProps {
    lineItem: any;
    hideNotAvailableVehicles: any;
    dateTimeDictionary?: any | null;
    dateTimeDictionaryOneDay?: any | null;
}

const useStyles = makeStyles()((theme: Theme) => ({
    stationGroup: {
        position: "relative",
        display: "inline-block",
        width: "100%",
        marginTop: 20,
        paddingLeft: 15,
    },

    stationGroupHeadLine: {
        fontSize: "1rem",
        fontWeight: 700,
        marginBottom: 6.5,
        marginTop: 6.5,
    },

    stationGroupToggle: {
        marginRight: 5,
        fontWeight: 400,
        cursor: "pointer",
    },

    cropTitle: {
        textOverflow: "ellipsis",
        width: 200,
        display: "inline-block",
        position: "absolute",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },

    vehicleNotAvailableIcon: {
        fontSize: 17,
        cursor: "pointer",
        position: "absolute",
        marginRight: 5,
        left: 222,
        fontWeight: 400,
    },

    stationInfoIcon: {
        fontSize: 17,
        cursor: "pointer",
        position: "absolute",
        marginRight: 5,
        left: 277,
        fontWeight: 400,
    },

    hideCarsIcon: {
        fontSize: 17,
        cursor: "pointer",
        position: "absolute",
        marginRight: 5,
        left: 249,
        fontWeight: 400,
    },

    dragBox: {
        height: "100%",
        position: "absolute",
        left: 306,
        top: 0,
        width: "100%",
        borderTop: "1px solid #000000",
        borderBottom: "1px solid #000000",
    },
}));

const StationLine: FunctionComponent<DispositionLineProps> = ({
                                                                  lineItem,
                                                                  hideNotAvailableVehicles,
                                                                  dateTimeDictionary,
                                                                  dateTimeDictionaryOneDay,
                                                              }): JSX.Element => {
    const {classes} = useStyles();
    const history = useHistory();
    const {contentWidth} = useAppSelector((state) => state.app);
    const {hideVehiclesInStations, hiddenStations} = useAppSelector(
        (state) => state.disposition
    );
    const dispatch = useAppDispatch();
    const confirm = useConfirm();
    const mandant = useSelector((state) => selectMandant(state));
    const {t} = useTranslation();

    const [bookingViewIsOpen, setBookingViewIsOpen] =
        React.useState<boolean>(false);
    const [lastClickXPos, setLastClickXPos] = React.useState<number>(0);

    const enabledStations = useSelector((state) =>
        selectViewerEnabledStations(state as ViewerState)
    );
    const newBookingAllowed =
        enabledStations.filter(
            (station: any) =>
                station.isChangeableInDispo == "J" &&
                station.stationId === lineItem.stationId
        ).length > 0;

    const {
        days,
        dayWidth,
        dispositionStartdate,
        dispositionEnddate,
        stationFilter,
    } = useAppSelector((state) => state.disposition);

    const allowedDropEffect = "any";
    const [{canDrop, isOver}, drop] = useDrop(
        () => ({
            accept: "booking",
            drop: () => ({
                type: "station",
                destination: {
                    vehicleId: null,
                    stationId: lineItem.stationId,
                    conflictBookings: null,
                    bookingId: lineItem.bookingId,
                },
                allowedDropEffect,
            }),
            canDrop: (item, monitor) => {
                // @ts-ignore
                return (
                    item?.booking?.startstation ===
                    lineItem.stationId
                );
            },
            collect: (monitor) => ({
                isOver: monitor.isOver(),
                canDrop: monitor.getItem() === null || monitor.canDrop(),
            }),
        }),
        [allowedDropEffect]
    );

    const renderBookingView = () => {
        if (!bookingViewIsOpen) {
            return <></>;
        }

        let clickedDate = dispositionStartdate;

        // @ts-ignore
        const a =
            lastClickXPos -
            (window.innerWidth -
                parseInt(document.getElementById("dispo_content").style.width) *
                (dayWidth / 100) *
                days);
        let b = 0;
        let i = 1;

        if (days === 1) {
            // @ts-ignore
            const c =
                lastClickXPos -
                (window.innerWidth -
                    parseInt(
                        document.getElementById("dispo_content").style.width
                    ) *
                    (dayWidth / 100) *
                    24);

            // @ts-ignore
            const x =
                c %
                (parseInt(
                        document.getElementById("dispo_content").style.width
                    ) *
                    (dayWidth / 100));

            // @ts-ignore
            while (
                c >=
                parseInt(document.getElementById("dispo_content").style.width) *
                (dayWidth / 100) *
                i
                ) {
                i++;
                b++;
            }

            // @ts-ignore
            const closest = Object.keys(dateTimeDictionaryOneDay).reduce(
                (prev, curr) => {
                    // @ts-ignore
                    return Math.abs(curr - x) < Math.abs(prev - x)
                        ? curr
                        : prev;
                }
            );

            const [hours, minutes] =
                dateTimeDictionaryOneDay[closest].split(":");

            clickedDate = moment(clickedDate).toDate();
            clickedDate.setHours(parseInt(hours) + b + 1, parseInt(minutes));
        } else {
            // @ts-ignore
            const x =
                a %
                (parseInt(
                        document.getElementById("dispo_content").style.width
                    ) *
                    (dayWidth / 100));

            // @ts-ignore
            while (
                a >=
                parseInt(document.getElementById("dispo_content").style.width) *
                (dayWidth / 100) *
                i
                ) {
                i++;
                b++;
            }

            clickedDate = moment(clickedDate).add(b, "d").toDate();

            // @ts-ignore
            const closest = Object.keys(dateTimeDictionary).reduce(
                (prev, curr) => {
                    // @ts-ignore
                    return Math.abs(curr - x) < Math.abs(prev - x)
                        ? curr
                        : prev;
                }
            );

            const [hours, minutes] = dateTimeDictionary[closest].split(":");

            clickedDate.setHours(parseInt(hours) + 2, parseInt(minutes));
        }

        history.push(
            "/manager/reservation/new/show?predefinedStartdate=" +
            moment(clickedDate).format("YYYY-MM-DDTHH:mm") +
            "&predefinedStartstationId=" +
            lineItem.stationId
        );
    };

    return (
        <>
            {renderBookingView()}
            {!canDrop && (
                <div
                    style={{
                        background: "rgba(255,0,0,0.5)",
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        zIndex: 51,
                    }}
                />
            )}
            <div className={classes.stationGroup}>
                <h5 className={classes.stationGroupHeadLine}>
                    <Tooltip
                        title={
                            hiddenStations.indexOf(lineItem.stationId) === -1
                                ? t("disposition.actions.hideStation")
                                : t("disposition.actions.showStation")
                        }
                    >
                        <span
                            data-id={lineItem.stationId}
                            className={classes.stationGroupToggle}
                            onClick={() => {
                                dispatch({
                                    type: TOGGLE_STATION,
                                    data: {stationId: lineItem.stationId},
                                });
                            }}
                        >
                            {hiddenStations.indexOf(lineItem.stationId) ===
                            -1 ? (
                                <KeyboardArrowDownIcon
                                    style={{fontWeight: 400}}
                                />
                            ) : (
                                <KeyboardArrowUpIcon
                                    style={{fontWeight: 400}}
                                />
                            )}
                        </span>
                    </Tooltip>
                    <span
                        className={classes.cropTitle}
                        title={lineItem.stationId + " - " + lineItem.disponame}
                    >
                        {lineItem.stationId + " - " + lineItem.disponame}
                    </span>
                    <Tooltip
                        title={
                            hideNotAvailableVehicles.indexOf(
                                lineItem.stationId
                            ) !== -1
                                ? t(
                                    "disposition.actions.showNotAvailableVehicleGroups"
                                )
                                : t(
                                    "disposition.actions.hideNotAvailableVehicleGroups"
                                )
                        }
                    >
                        <span
                            className={classes.vehicleNotAvailableIcon}
                            onClick={() => {
                                logger.log(
                                    "user clicked hideNotAvailableVehicles Button for station " +
                                    lineItem.stationId
                                );
                                dispatch({
                                    type: TOGGLE_HIDE_UNAVAILABLE_VEHICLES,
                                    data: {stationId: lineItem.stationId},
                                });
                            }}
                        >
                            {hideNotAvailableVehicles.indexOf(
                                lineItem.stationId
                            ) !== -1 ? (
                                <EventBusyOutlinedIcon
                                    style={{fontWeight: 400}}
                                />
                            ) : (
                                <DateRangeOutlined
                                    style={{fontWeight: 400}}
                                />
                            )}
                        </span>
                    </Tooltip>
                    <Tooltip
                        title={t("disposition.actions.displayStationInfo")}
                    >
                        <span
                            className={classes.stationInfoIcon}                  
                            onClick={() => {
                                logger.log(
                                    "user clicked openStationInfo Button for station " +
                                    lineItem.stationId
                                );
                                dispatch({
                                    type: OPEN_STATION_INFO,
                                    data: {item: lineItem},
                                });
                            }}
                        >
                            <InfoOutlinedIcon style={{fontWeight: 400}}/>
                        </span>
                    </Tooltip>
                    <Tooltip
                        title={
                            hideVehiclesInStations.indexOf(
                                lineItem.stationId
                            ) === -1
                                ? t("disposition.actions.hideVehicles")
                                : t("disposition.actions.showVehicles")
                        }
                    >
                        <span
                            data-id={lineItem.stationId}
                            className={classes.hideCarsIcon}
                            onClick={() => {
                                logger.log(
                                    "user clicked toggleVehiclesInStation Button for station " +
                                    lineItem.stationId
                                );
                                dispatch({
                                    type: TOGGLE_VEHICLES_IN_STATION,
                                    data: {stationId: lineItem.stationId},
                                });
                            }}
                        >
                            {hideVehiclesInStations.indexOf(
                                lineItem.stationId
                            ) === -1 ? (
                                <VisibilityOutlinedIcon
                                    style={{fontWeight: 400}}
                                />
                            ) : (
                                <VisibilityOffOutlinedIcon
                                    style={{fontWeight: 400}}
                                />
                            )}
                        </span>
                    </Tooltip>
                </h5>
                <div
                    data-stationid={lineItem.stationId}
                    ref={drop}
                    onClick={(event) => {
                        logger.log(
                            "user clicked station line " + lineItem.stationId
                        );
                        if (mandant.abasId === 70447) {
                            return;
                        }
                        if (!newBookingAllowed) {
                            return;
                        }
                        confirm({
                            description: t(
                                "disposition.messages.createNewGroupReservation"
                            ),
                            confirmationText: t("general.yes"),
                            cancellationText: t("general.no"),
                        })
                            .then(() => {
                                logger.log(
                                    "user clicked createNewGroupRes Button for station " +
                                    lineItem.stationId
                                );
                                setLastClickXPos(event.clientX);
                                setBookingViewIsOpen(true);
                            })
                            .catch(() => {
                                logger.log(
                                    "user canceled create new group res Button for station " +
                                    lineItem.stationId
                                );
                            });
                    }}
                    className={classes.dragBox}
                />
            </div>
        </>
    );
};

export default React.memo(StationLine);
